function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.7161 41.4948C56.7161 41.4948 50.6821 43.7677 47.0583 48.9157C43.3064 54.2458 49.4516 71.6335 49.4516 71.6335L56.7161 41.4948Z",
  fill: "#E4E1FF",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M89.3358 38.4955C91.4583 38.8426 92.7989 42.7447 92.7989 42.7447C92.7989 42.7447 94.3924 42.0796 95.9959 42.7419C97.5993 43.4043 99.2021 44.9439 99.1998 47.5121C99.1974 50.0802 98.2781 53.6765 95.9781 61.8966C93.6781 70.1167 81.4938 89.0059 81.4938 89.0059C81.4938 89.0059 51.4686 84.5046 48.0318 80.9633C48.4961 59.4258 53.7774 47.6824 57.499 39.8429C61.2207 32.0034 68.0217 13.1526 69.5404 10.3807C71.059 7.60888 73.1994 6.22674 75.9655 6.88121C78.7316 7.53568 79.0201 10.4525 78.4883 13.143C74.4271 33.6915 84.5633 37.715 89.3358 38.4955Z",
  fill: "#E4E1FF",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M85.3035 39.4657L88.0226 14.1799C88.2697 11.8821 86.6969 9.84986 84.4037 9.50376C82.0275 9.14514 79.7156 10.719 79.1739 13.0639L73.4875 37.6824L85.3035 39.4657Z",
  fill: "#E4E1FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M84.5983 38.9737L88.1956 15.554C88.5751 13.0833 86.918 10.8349 84.4423 10.4613V10.4613C81.9919 10.0914 79.6004 11.6896 78.9986 14.0993L71.5307 44.0007",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4557 47.7157L92.4557 43.4288C92.4557 42.4895 92.2335 41.5663 91.8071 40.7341L86.2403 29.8678L83.2865 46.3447",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M48 78H90V88H48V78Z",
  fill: "white",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_17206_39306)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 6,
  width: 70,
  height: 34,
  fill: "#FFBB00"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 75.1292,
  cy: 22.9993,
  rx: 10.1613,
  ry: 10.2,
  fill: "white",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 106.229,
  cy: 7.21045,
  rx: 6.20968,
  ry: 5.5,
  fill: "#1B1B1B"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 41.8223,
  cy: 8.49951,
  rx: 6.20968,
  ry: 5.5,
  fill: "#1B1B1B"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 107.259,
  cy: 37.9721,
  rx: 6.20968,
  ry: 6.23333,
  fill: "#1B1B1B"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 41.8223,
  cy: 37.1669,
  rx: 6.20968,
  ry: 6.23333,
  fill: "#1B1B1B"
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 39.75,
  y: 6.75,
  width: 68.5,
  height: 32.5,
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M70.874 49.2915L78.4841 11.8965C78.9728 9.49507 77.513 7.1604 75.1389 6.54645C72.7791 5.9362 70.3093 7.23192 69.4632 9.52413L57.3511 42.3362L70.874 49.2915Z",
  fill: "#E4E1FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M72.2324 44.0321L78.5125 11.9339C78.9894 9.49641 77.4985 7.13929 75.0902 6.52325V6.52325C72.7402 5.92211 70.2782 7.17648 69.3746 9.43528L56.8152 40.8336",
  stroke: "#1B1B1B",
  strokeWidth: 1.5,
  strokeLinecap: "square"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M44 84V106L94 106V84L44 84Z",
  fill: "#6B57FF",
  stroke: "#1B1B1B",
  strokeWidth: 1.5
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.448 5.66709C14.3755 4.62594 15.7461 4.18375 16.2957 5.07099L18.4225 8.50433C18.5912 8.77676 18.8803 8.95182 19.2 8.97509L23.2422 9.26941C24.1384 9.33466 24.5005 10.4569 23.8114 11.0336L20.7033 13.6348C20.4575 13.8405 20.3252 14.1515 20.3475 14.4712L20.6282 18.5001C20.7007 19.5412 19.3301 19.9834 18.7805 19.0962L16.6537 15.6628C16.4849 15.3904 16.1958 15.2154 15.8762 15.1921L11.834 14.8978C10.9378 14.8325 10.5757 13.7102 11.2648 13.1335L14.3729 10.5324C14.6187 10.3267 14.751 10.0157 14.7287 9.69601L14.448 5.66709Z",
  fill: "#FFBB00"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M118.253 82.536C118.878 82.0858 119.755 82.4803 119.833 83.2462L120.559 90.4032C120.637 91.169 119.857 91.7318 119.154 91.4162L112.593 88.4667C111.891 88.151 111.794 87.1937 112.418 86.7434L118.253 82.536Z",
  fill: "#C1B9FF"
});

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_17206_39306"
}, /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 6,
  width: 70,
  height: 34,
  fill: "white"
})));

var SvgPaid = function SvgPaid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 112,
    viewBox: "0 0 148 112",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paid.b04af832.svg";
export { ForwardRef as ReactComponent };